import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FileWarning } from 'lucide-react';
import staffRecordService from '../../services/staffRecords';

/**
 * On the Dashboard: a warning sent to you and not yet acknowledged. Renders
 * nothing otherwise, or if the count cannot be read; the notification is the
 * other way in.
 */
export default function MyWarningsBanner({ refreshKey }: { refreshKey?: unknown }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    staffRecordService.myWarningCount()
      .then(res => { if (!cancelled) setCount(res.count); })
      .catch(() => { if (!cancelled) setCount(0); });
    return () => { cancelled = true; };
  }, [refreshKey]);

  if (count === 0) return null;
  return (
    <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 flex items-start gap-3">
      <FileWarning className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-amber-900">
          {count === 1 ? 'You have a warning to read' : `You have ${count} warnings to read`}
        </p>
        <p className="text-sm text-amber-800">Your employer has asked you to read and acknowledge it.</p>
      </div>
      <Link to="/my-warnings" className="text-sm font-medium text-amber-900 underline shrink-0">Read</Link>
    </div>
  );
}
